"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStripePromise = exports.StripePromiseProvider = void 0;
const React = require("react");
const react_1 = require("react");
const stripe_js_1 = require("@stripe/stripe-js");
const RetailLocationsContext_1 = require("../../../../features/base/ordering/contexts/RetailLocationsContext");
const publicKey = env.stripePublishableKey;
const StripePromiseContext = (0, react_1.createContext)({});
const StripePromiseProvider = ({ children, storeStripeAccountId }) => {
    //spg contexts
    const { retailLocation } = (0, react_1.useContext)(RetailLocationsContext_1.RetailLocationsContext);
    let myStoreId = storeStripeAccountId !== null && storeStripeAccountId !== void 0 ? storeStripeAccountId : retailLocation.stripePaymentGatewayId;
    //stripe contexts
    const [stripePlatform, setStripePlatform] = (0, react_1.useState)();
    const [stripeStore, setStripeStore] = (0, react_1.useState)();
    const loadStripeAccounts = async () => {
        const stripePlatformResult = await (0, stripe_js_1.loadStripe)(publicKey);
        const stripeStoreResult = await (0, stripe_js_1.loadStripe)(publicKey, {
            stripeAccount: myStoreId
        });
        //load the platform account
        if (stripePlatformResult) {
            setStripePlatform(stripePlatformResult);
            console.log("Loaded Platform Account");
        }
        //load the store account
        if (stripeStoreResult) {
            setStripeStore(stripeStoreResult);
            console.log("Loaded Store Account");
        }
    };
    (0, react_1.useEffect)(() => {
        loadStripeAccounts();
    }, []);
    const myContext = {
        StripePlatform: stripePlatform,
        StripeStore: stripeStore,
        StripeStoreAccountId: myStoreId
    };
    return (React.createElement(StripePromiseContext.Provider, { value: myContext }, children));
};
exports.StripePromiseProvider = StripePromiseProvider;
const useStripePromise = () => {
    const context = (0, react_1.useContext)(StripePromiseContext);
    if (context === undefined) {
        throw new Error("useStripePromise must be used within a StripePromiseProvider");
    }
    return context;
};
exports.useStripePromise = useStripePromise;
//# sourceMappingURL=StripePromiseProvider.js.map